import { Switch } from '@mui/material'
import React from 'react'
import { Controller } from 'react-hook-form'

const ToggleInput = ({ control, name, label }) => {
  return (
    <Controller
      control={control}
      name={name}
      render={({ field: { value, onChange } }) => (
        <Switch
          color='primary'
          checked={value}
          onChange={onChange}
          inputProps={{ 'aria-label': label }}
          data-test={`${name}-toggle`}
        />
      )}
    />
  )
}

export default ToggleInput
